<p-toast />
<div id="compiance-settings" data-cy="compiance-settings">
    <h1>Compliance Settings</h1>
    <!-- each child entity campaign gets a separate card -->
    <p-card styleClass="mb-4">
        <h3 class="mt-2 mb-4">Garret Graves for Congress</h3>
        <form>
            <div class="formgrid grid">
                <div class="field col-12 sm:col-6 xl:col-4">
                    <label for="committieType" class="field-label required">Committie Type</label>
                    <!-- [options]="committieTypes" (onChange)="committieTypeChanged($event)" -->
                    <p-dropdown id="committieType" formControlName="selectedCommittieType"  optionLabel="text" placeholder="Please Select"  dataKey="value" />
                    <!-- <div *ngIf="form.controls['committieType'].invalid && form.controls['committieType'].touched" class="block p-error">
                        <small id="committieType-error" class="error"> Please select Committie Yype. </small>
                    </div> -->
                </div>
                <div class="field col-12 sm:col-6 xl:col-4">
                    <label for="regulatoryBody" class="field-label required">Regulatory Body</label>
                    <!-- [options]="regulatoryBodys" (onChange)="regulatoryBodyChanged($event)" -->
                    <p-dropdown id="regulatoryBody" formControlName="selectedRegulatoryType"  optionLabel="text" placeholder="Please Select"  dataKey="value" />
                    <!-- <div *ngIf="form.controls['regulatoryBody'].invalid && form.controls['regulatoryBody'].touched" class="block p-error">
                        <small id="regulatoryBody-error" class="error"> Please select Regulatory Body. </small>
                    </div> -->
                </div>
                <div class="field col-0 xl:col-4">
                </div>
                <div class="field col-12 sm:col-6 xl:col-4">
                    <label for="formType" class="field-label required">Form Type</label>
                    <!-- [options]="formTypes" (onChange)="formTypeChanged($event)" -->
                    <p-dropdown id="formType" formControlName="selectedFormType"  optionLabel="text" placeholder="Please Select"  dataKey="value" />
                    <!-- <div *ngIf="form.controls['formType'].invalid && form.controls['formType'].touched" class="block p-error">
                        <small id="formType-error" class="error"> Please select Form type. </small>
                    </div> -->
                </div>
                <div class="field col-12 sm:col-6 xl:col-4">
                    <label for="revenueLineNumber" class="field-label required">Default Revenue Line Number</label>
                    <!-- [options]="revenueLineNumbers" (onChange)="revenueLineNumberChanged($event)" -->
                    <p-dropdown id="revenueLineNumber" formControlName="selectedRevenueLineNumber"  optionLabel="text" placeholder="Please Select"  dataKey="value" />
                    <!-- <div *ngIf="form.controls['revenueLineNumber'].invalid && form.controls['revenueLineNumber'].touched" class="block p-error">
                        <small id="revenueLineNumber-error" class="error"> Please select committie type. </small>
                    </div> -->
                </div>
                <div class="field col-12 sm:col-6 xl:col-3">
                    <label for="expenseLineNumber" class="field-label required">Default Expense Line Number</label>
                    <!-- [options]="expenseLineNumbers" (onChange)="expenseLineNumberChanged($event)" -->
                    <p-dropdown id="expenseLineNumber" formControlName="selectedExpenseLineNumber"  optionLabel="text" placeholder="Please Select"  dataKey="value" />
                    <!-- <div *ngIf="form.controls['expenseLineNumber'].invalid && form.controls['expenseLineNumber'].touched" class="block p-error">
                        <small id="expenseLineNumber-error" class="error"> Please select committie type. </small>
                    </div> -->
                </div>
                <div class="pt-4">
                    <rc-generic-button borderStyle="solid" [classes]="['mt-1']" size="small" label="Save" />
                </div>
            </div>
        </form>
    </p-card>
</div>